export default __webpack_public_path__ + "static/media/register.24c0a62e.svg";